module.exports = __webpack_public_path__ + "img/停用2.4a27da1a.png";